export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.25 12a.75.75 0 01.75-.75h8a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 8.75c-.825 0-1.576.306-2.15.812a.75.75 0 01-.992-1.124 4.75 4.75 0 110 7.125.75.75 0 01.992-1.125A3.25 3.25 0 1017 8.75zM7 15.25c.825 0 1.576-.306 2.15-.812a.75.75 0 11.992 1.124 4.75 4.75 0 110-7.125.75.75 0 01-.992 1.125A3.25 3.25 0 107 15.25z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};